import * as React from 'react';
import { Link } from 'react-router-dom';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { IAlerts } from 'src/services/account';

const renderRoute = (r: IRoute, alerts: IAlerts | null | undefined) => {
    return (
        <li className="nav-item" key={`nav-item-${r.path}`}>
            <Link to={r.path} className={`nav-link ${location.pathname === r.path ? 'active' : ''}`}>
                <i className={`fas fa-${r.icon}`} /> {r.name}
                {renderBadge(r, alerts)}
            </Link>
        </li>
    )
}

const renderBadge = (r: IRoute, alerts: IAlerts | null | undefined) => {
    if (alerts) {
        const keys = Object.keys(alerts);
        return keys.map((k) => {
            if (r.path.includes(k) && alerts[k] > 0) {
                return (<span className="badge badge-danger" key={`badge-${r.name}-${alerts[k]}`}>{alerts[k]}</span>);
            } else {
                return null;
            }
        });
    }
    else {
        return null;
    }
}

export default injectIntl((props: InjectedIntlProps & { location: Location, routes: IRoute[], alerts: IAlerts | null | undefined }) => {

    return (
        <div className="side-nav col">
            <ul className="nav nav-tabs main-tabnab" role="tablist">
                {props.routes.map((r) => renderRoute(r, props.alerts))}
            </ul>
        </div>
    );
});



// WEBPACK FOOTER //
// ./src/client/dashboard/SideNav.tsx